import { ProtocolSettings } from "./ProtocolSettings";
import { SnmpSettings } from "./SnmpSettings";
import { PingSettings } from "./PingSettings";
import { WindowsSettings } from "./WindowsSettings";
import { SshSettings } from "./SshSettings";
import { TelnetSettings } from "./TelnetSettings";
import { VimSettings } from "./VimSettings";
import { PrtgSettings } from "./PrtgSettings";
import { HttpSettings } from "./HttpSettings";

export class ProtocolSettingsFactory {

	public static Create(value: any): ProtocolSettings {
		if (value.snmp)
			return new SnmpSettings();
		else if (value.ping)
			return new PingSettings();
		else if (value.windows)
			return new WindowsSettings();
		else if (value.ssh)
			return new SshSettings();
		else if (value.telnet)
			return new TelnetSettings();
		else if (value.vim)
			return new VimSettings();
		else if (value.prtg)
			return new PrtgSettings();
		else if (value.http)
			return new HttpSettings();
		else {
			console.assert(false);
			return null;
		}
	}

}

